"use client";
import React, { FC } from "react";
import { ColumnDef } from "@tanstack/react-table";

import { useParcels } from "@/context/Parcels.context";
import { EmptyData, Loader, Table } from "@/components/common";
import { ModalType, Theme } from "@/enums";
import { IShipment } from "@/types/apiResponse.types";
import { useTheme } from "@/context/Theme.context";

type Props = {
  data: IShipment[];
  isLoading: boolean;
  columns: ColumnDef<any>[];
};

const ParcelsTable: FC<Props> = ({ data, isLoading, columns }) => {
  const { openParcelsModal } = useParcels();
  const theme = useTheme();

  if (isLoading) {
    return <Loader />;
  }

  if (!isLoading && data.length === 0) {
    return theme === Theme.UK ? null : (
      <EmptyData title="empty_parcels" subtitle="empty_parcels_subtitle" />
    );
  }

  return (
    <div className="mt-8">
      <Table
        columns={columns}
        data={data}
        onClickRow={(row) => {
          openParcelsModal({
            id: row?.shipmentId,
            modalType: ModalType.VIEW,
          });
        }}
      />
    </div>
  );
};

export default ParcelsTable;
